import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import Terms from "components/terms/Terms/Terms";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const TermsPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Términos y condiciones | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <Terms />
      </TabsMenu>
    </>
  );
};

export default TermsPage;
